import React from 'react';

class DebouncedInput extends React.Component {

  state = {
    value: '',
    delayedChange: null
  }

  handleChange = (value) => {
    // console.log('handleChange', value);
    const delayedChange = setTimeout(this.sendUpdate, this.props.delay || 1000);

    this.setState(prev => {
      // console.log('prev.delayedChange', prev.delayedChange);
      if (prev.delayedChange) {
        // console.log('clearTimeout', prev.delayedChange);
        clearTimeout(prev.delayedChange);
      }

      return {
        ...prev,
        delayedChange,
        value
      }
    });
  }

  sendUpdate = () => {
    // console.log('sendUpdate', this.state.value, this.props.onChange);
    this.props.onChange(this.state.value);
    this.setState({ delayedChange: null });
  }

  componentDidMount = () => {
    // console.log('componentDidMount', this.props.value)
    if (this.props.value) {
      this.setState({ value: this.props.value });
    }
  }

  componentWillUnmount = () => {
    // console.log('componentWillUnmount', this.state);
    clearTimeout(this.state.delayedChange);
  }

  render() {
    return (
      <input
        className={`input ${this.props.className || ''}`}
        value={this.state.value}
        placeholder={this.props.placeholder || 'debounced input'}
        onChange={e => this.handleChange(e.target.value)} />
    );
  }
}

export default DebouncedInput;
